import { actionTypes_exports } from "./actionTypes.mjs";
import { actions_exports } from "./actions.mjs";
import reducer, { initialState } from "./reducer.mjs";
//#region src/store/session/index.ts
var session_default = {
	actions: actions_exports,
	actionTypes: actionTypes_exports,
	initialState,
	reducer
};
//#endregion
export { session_default as default };

//# sourceMappingURL=index.mjs.map